import { HourglassIcon } from "../../images/icons/icons";

export const getCardLabel = (key) => {
  switch (key) {
    case "total":
      return "total engagements";
    case "not_approved":
      return "approval pending";
    case "total_active_subs":
      return "Active Members";
    case "trainer_unmapped":
      return "Members Not Mapped with Trainer";
    case "trainer_mapped":
      return "Members Mapped with Trainer";
    case "deleted_trainer_mapped":
      return "Members Mapped with Deleted Trainer";
    case "total_expired_subs":
      return "Expired Members";
    default:
      return key.replace(/_/g, " ");
  }
};

export const getCardIcon = (key) => {
  switch (key) {
    case "both_present":
      return <HourglassIcon />;
    default:
      return <HourglassIcon />;
  }
};
